export { PageHeadingLayout } from './PageHeadingLayout';
